import React from 'react';
import { useForm } from 'react-hook-form';
import Modal from '../../../shared/components/ui/Modal';
import FormInput from '../../../shared/components/ui/FormInput';
import Button from '../../../shared/components/ui/Button';

const DueDateReasonModal = ({
  onClose,
  onConfirm,
  title = 'Reason for due date change',
  body = 'Work has already started. Enter a reason to change the due date.',
  helper,
  confirmLabel = 'Save with reason'
}) => {
  const { register, handleSubmit } = useForm({
    defaultValues: { reason: '' }
  });

  const onSubmit = (data) => {
    const reason = String(data.reason || '').trim();
    if (!reason) return;
    onConfirm(reason);
  };

  return (
    <Modal name={title} width={40} onClose={onClose} hideClose={false}>
      <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
        <p className="text-sm text-gray-600">{body}</p>
        {helper ? (
          <p className="text-sm text-amber-800 bg-amber-50 border border-amber-100 rounded px-3 py-2">
            {helper}
          </p>
        ) : null}
        <FormInput
          label="Reason"
          register={register}
          register_key="reason"
          type="textarea"
          isRequired={true}
          width={100}
        />
        <div className="flex justify-end gap-3 pt-2">
          <Button
            type="button"
            onClick={onClose}
            className="bg-gray-200 text-gray-800 px-6 py-2 rounded hover:bg-gray-300"
          >
            Back
          </Button>
          <Button
            type="submit"
            className="bg-[#346C75] text-white px-8 py-2 rounded hover:bg-[#2a565e]"
          >
            {confirmLabel}
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default DueDateReasonModal;
